import { SVGComponentPropsType } from 'assets/types';
import colors from 'styles/colors';

const defaultSize = 12;

const OpenStatusIcon = ({
  size = defaultSize,
  color = colors.agreementStatusOpen,
  ...props
}: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <circle cx="15" cy="12" r="6" transform="translate(-9 -6)" fill={color} fillRule="evenodd" />
  </svg>
);

export default OpenStatusIcon;
